import { useJurisdictionStore } from './use-jurisdiction';

export const useIsNewArcadePlatform = () =>
    useJurisdictionStore(state => !!state.jurisdictionSettings?.productConfig?.settings?.enable_new_platform);
